import { SETTINGS, COLORS } from '../config/settings';

export class ScoreSystem {
  private score: number = 0;
  private highScore: number = 0;
  private combo: number = 0;
  private comboTimer: number = 0;
  private multiplier: number = 1;

  constructor() {
    this.loadHighScore();
  }

  private loadHighScore(): void {
    const saved = localStorage.getItem('ham_highscore');
    if (saved) {
      this.highScore = parseInt(saved, 10);
    }
  }

  private saveHighScore(): void {
    if (this.score > this.highScore) {
      this.highScore = this.score;
      localStorage.setItem('ham_highscore', this.highScore.toString());
    }
  }

  public addScore(points: number, playerMultiplier: number = 1): void {
    // Calculate total multiplier
    const totalMultiplier = this.getMultiplier() * playerMultiplier;
    const finalPoints = Math.floor(points * totalMultiplier);
    
    this.score += finalPoints;
    this.combo++;
    this.comboTimer = SETTINGS.COMBO_TIMEOUT;
    
    // Save if new high score
    this.saveHighScore();
  }

  public addBonus(points: number): void {
    this.score += points;
    this.saveHighScore();
  }

  public update(deltaTime: number): void {
    if (this.comboTimer > 0) {
      this.comboTimer -= deltaTime;
      if (this.comboTimer <= 0) {
        this.resetCombo();
      }
    }
  }

  public resetCombo(): void {
    this.combo = 0;
    this.multiplier = 1;
  }

  public getMultiplier(): number {
    // Combo tiers: 0-9 = 1x, 10-24 = 1.5x, 25-49 = 2x, 50-99 = 3x, 100+ = 5x
    if (this.combo >= 100) return SETTINGS.COMBO_MULTIPLIERS[4];
    if (this.combo >= 50) return SETTINGS.COMBO_MULTIPLIERS[3];
    if (this.combo >= 25) return SETTINGS.COMBO_MULTIPLIERS[2];
    if (this.combo >= 10) return SETTINGS.COMBO_MULTIPLIERS[1];
    return SETTINGS.COMBO_MULTIPLIERS[0];
  }

  public render(ctx: CanvasRenderingContext2D, x: number, y: number): void {
    ctx.fillStyle = COLORS.TEXT;
    ctx.textAlign = 'center'; // Center align for consistent spacing with other HUD elements
    ctx.textBaseline = 'top';

    // Hands: render as two lines (label above, big number below)
    ctx.font = 'bold 18px "Courier New"';
    ctx.fillText('HANDS', x, y);
    ctx.font = 'bold 36px "Courier New"';
    ctx.fillText(this.score.toLocaleString(), x, y + 22);

    // Combo (only show if active) - two-line style
    if (this.combo > 0) {
      const mult = this.getMultiplier();
      ctx.font = 'bold 16px "Courier New"';
      ctx.fillStyle = mult > 2 ? COLORS.SUCCESS : COLORS.PRIMARY;
      ctx.fillText('COMBO', x, y + 60);
      ctx.font = 'bold 24px "Courier New"';
      ctx.fillText(`${this.combo} (${mult}x)`, x, y + 80);
      // restore text color
      ctx.fillStyle = COLORS.TEXT;
    }
  }

  public getScore(): number {
    return this.score;
  }

  public getHighScore(): number {
    return this.highScore;
  }

  public getCombo(): number {
    return this.combo;
  }

  public reset(): void {
    this.saveHighScore();
    this.score = 0;
    this.combo = 0;
    this.comboTimer = 0;
    this.multiplier = 1;
  }
}
